import { render, staticRenderFns } from "./BookmarkedTeams.vue?vue&type=template&id=4335d2b2&"
import script from "./BookmarkedTeams.vue?vue&type=script&lang=js&"
export * from "./BookmarkedTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports